import React from 'react';
import PropTypes from 'prop-types';
import utils from '../../lib/utils';

class SubmissionsKpiDataListControls extends React.Component {
  selectClassName(controlActive) {
    let className = '';
    if (this.props.activeControl === controlActive) {
      className = 'is-primary';
    }
    return className;
  }

  optionsForDropDown(interval, format) {
    let optionValues = [];
    const dateStart = utils.getMomentDateByKey('startDate');
    const dateEnd = utils.getMomentDateByKey('currentDate');
    while (dateEnd > dateStart) {
       optionValues.push( {display: dateStart.format(format), value: dateStart.format('YYYY-MM-DD')});
       dateStart.add(1, interval);
    }
    return optionValues.reverse();
  }

  render() {
    const monthYearOptions = this.optionsForDropDown('month', 'MM/YYYY');
    const yearOptions = this.optionsForDropDown('year', 'YYYY');

    return (
      <div className="submissions-kpi-data-container-controls">
        <div className="submissions-kpi-data-container-controls__controls-dates-wrap">
          <div className="submissions-kpi-data-container-controls__controls-info">
            <div className="submissions-kpi-data-container-controls__controls-dropdown field">
              <p className="control">
                <span className={`select is-small ${this.selectClassName('MTD')}`}>
                  <select
                    className="month-year"
                    onChange={this.props.changeOfMonthYear}
                    value={this.props.activeControl !== 'MTD' ? '' : undefined}
                    defaultValue={monthYearOptions[0].value}
                  >
                    <option>
                      Month/Year
                    </option>
                    {monthYearOptions.map((op, i) => {
                      return (
                        <option
                          key={i}
                          value={op.value}
                        >
                          {op.display}
                        </option>
                      );
                    })}
                  </select>
                </span>
              </p>
            </div>
            <div className="submissions-kpi-data-container-controls__controls-dropdown field">
              <p className="control">
                <span className={`select is-small ${this.selectClassName('YTD')}`}>
                  <select
                    className="year"
                    onChange={this.props.changeOfYear}
                    value={this.props.activeControl !== 'YTD' ? '' : undefined}
                  >
                    <option defaultValue>
                      Year
                    </option>
                    {yearOptions.map((op, i) => {
                      return (
                        <option
                          key={i}
                          value={op.value}
                        >
                          {op.display}
                        </option>
                      );
                    })}
                  </select>
                </span>
              </p>
            </div>
            <div className="submissions-kpi-data-container-controls__controls-type-wrap">
              <div className="submissions-kpi-data-container-controls__controls-dropdown field">
                <p className="control">
                  <span className={`type-toggle select is-small is-primary`}>
                    <select
                      onChange={this.props.changeOfType}>
                      <option value="New">
                        {`New`}
                      </option>
                      <option value="Renewal">
                        {`Renewal`}
                      </option>
                      <option value="All">
                        {`All`}
                      </option>
                    </select>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SubmissionsKpiDataListControls.propTypes = {
  activeControl: PropTypes.string,
  changeOfYear: PropTypes.func,
  changeOfMonthYear: PropTypes.func,
  changeOfType: PropTypes.func
};

export default SubmissionsKpiDataListControls;
